import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  gap: ${props => props.spacing || '1rem'};
  /* grid-auto-rows: minmax(${props => props.height || '10rem'}, auto); */
  margin: ${props => `${props.my || '0'} ${props.mx || '0'}`};
  justify-content: ${props => props.justify || 'start'};
  align-items: ${props => props.align || 'start'};
`

const findLowerBreak = (size, props) => {
  let breaks = ["xl", "lg", "md", "sm", "smp", "xs"];
  // find exact match or next lower
  if (props[size]) {
    return props[size];
  }
  let i = breaks.indexOf(size);
  let found = "12";
  while (i < breaks.length) {
    if (props[breaks[i]]) {
      found = props[breaks[i]];
    }
    i++;
  }
  return found;
}

export const Row = styled.div`
  grid-column: ${props => props.xs ? `span ${props.xs}` : 'span 12'};

  @media ${props => props.theme.breaks.up('smp')} {
    grid-column: ${props => `span ${findLowerBreak('smp', props)}`};
  }
  @media ${props => props.theme.breaks.up('sm')} {
    grid-column: ${props => `span ${findLowerBreak('sm', props)}`};
  }
  @media ${props => props.theme.breaks.up('md')} {
    grid-column: ${props => `span ${findLowerBreak('md', props)}`};
  }
  @media ${props => props.theme.breaks.up('lg')} {
    grid-column: ${props => `span ${findLowerBreak('lg', props)}`};
  }
  @media ${props => props.theme.breaks.up('xl')} {
    grid-column: ${props => `span ${findLowerBreak('xl', props)}`};
  }
`